import { SelectionRowWrapper } from 'components/rest/Table/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SelectionRow({ selected, children, setSelectedRowKeys }) {
  const { t } = useTranslation();
  return (
    <SelectionRowWrapper className="row-table-selection">
      {t('common.totalSelected', { total: selected.length })}
      {React.cloneElement(children, {
        selected,
        setSelectedRowKeys,
      })}
    </SelectionRowWrapper>
  );
}
